/**
 * CompanyEmptyState 컴포넌트 - 회사 목록 빈 상태
 */

import { Card } from '../ui/card';
import { Building2 } from 'lucide-react';
import type { CompanyTranslations } from './types';

interface CompanyEmptyStateProps {
  translations: CompanyTranslations;
}

export function CompanyEmptyState({ translations: t }: CompanyEmptyStateProps) {
  return (
    <Card className="p-6 bg-background rounded-[5px] border border-border text-center">
      <div className="w-16 h-16 bg-muted rounded-[5px] flex items-center justify-center mx-auto mb-3">
        <Building2 className="w-8 h-8 text-foreground-muted" />
      </div>
      <h3 className="text-[15px] font-medium text-muted-foreground mb-1">
        {t.noCompanies}
      </h3>
      <p className="text-foreground-muted text-[13px]">
        {t.addFirstCompany}
      </p>
    </Card>
  );
}
